import React from "react";
import { graphql } from "gatsby";
import NavHeader from "../components/nav-header";
import SectionBreak from "../components/section-break";
import BannerImage from "../components/banner-image";
import StandardPage from "../components/standard-page";
import StandardSection from "../components/standard-section";
import Seo from "../components/seo";
import CardSearch from "../components/card-search";

export default function Tips({
  data, // this prop will be injected by the GraphQL query below.
  location,
}) {
  return (
    <StandardPage
      header={
        <NavHeader>
          <BannerImage childImageSharp={data.file.childImageSharp} />
        </NavHeader>
      }
    >
      <StandardSection title="Travel Tips">
        <p className="text-center">
          I want to make your next trip or hike easier! I share tips to getting
          started outdoors, hiking gear recommendations and more.
        </p>
      </StandardSection>
      <SectionBreak>
        <h1 className="uppercase text-5xl">
          How can I make your next trip easier?
        </h1>
      </SectionBreak>

      <CardSearch filters="type:Tip"></CardSearch>

      <Seo title="Travel Tips" cover={data.file} slug="/tips/" type={false} />
    </StandardPage>
  );
}

export const pageQuery = graphql`
  query {
    file(relativePath: { eq: "zion.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;
